import { ConstraintPopSlidesAllowableDayBase } from './base/constraint-pop-slides-allowable-day-base';

export class ConstraintPopSlidesAllowableDay extends ConstraintPopSlidesAllowableDayBase { }